import { isEqual } from 'lodash';
import { arrayOf, object } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import AsyncTable from '../../generic/Table/AsyncTable';
import { reactTableColumnShape } from '../../prop-types';
import api from '../../REST/api';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function AsyncList({ columns, searchParams, ...rest }) {
  // Using this state to dynamically update data in react-table
  // since contact filters are data passed externally to it and
  // hence it doesnt update automatically on change of filters.
  const [key, setKey] = useState(0);
  const prevSearchParams = usePrevious(searchParams);

  // Additional check needed here since useEffect does not do
  // deep comparison for objects so re rendering takes place even
  // if the object values are same
  useEffect(() => {
    if (!isEqual(prevSearchParams, searchParams)) setKey(keyVal => +!keyVal);
  }, [searchParams, prevSearchParams]);

  return (
    <AsyncTable
      minRows={2}
      key={key}
      columns={columns}
      allColumns={columns}
      queryFn={({ search }) => {
        return api.getContacts({
          search: { ...searchParams, ...search },
        });
      }}
      {...rest}
    />
  );
}

AsyncList.propTypes = {
  columns: arrayOf(reactTableColumnShape).isRequired,
  searchParams: object, // eslint-disable-line react/forbid-prop-types,
};

AsyncList.defaultProps = {
  searchParams: undefined,
};

export default AsyncList;
